import { render, staticRenderFns } from "./SingleLayerMainInfos.vue?vue&type=template&id=6ff0620a&scoped=true"
import script from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerMainInfos.vue?vue&type=style&index=0&id=6ff0620a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0620a",
  null
  
)

export default component.exports